import { useParams, useNavigate } from "react-router"
import { useGetVendorRewardsQuery } from "@apis/rewards/useRewards"
import {
  tableColumnsVendorSummary,
  tableColumnsFulfillmentBatches,
} from "./utils/tableColumnsSchema"
import { DataTable } from "@components/DataTable/DataTable"
import { PageTitle } from "@components/PageTitle"
import { Button } from "@components/ui/button"
import { MoveLeft } from "lucide-react"
import { useSortingState } from "@hooks/useSortingState"

export const VendorRewards = () => {
  const navigate = useNavigate()
  const { fulfillment_vendor_code } = useParams() as {
    fulfillment_vendor_code: string
  }

  const { data, isPending, isError, error } = useGetVendorRewardsQuery(
    fulfillment_vendor_code,
  )

  const sortingPending = useSortingState([
    { id: "rewards_pending_approved_amount_count", desc: true },
  ])
  const sortingBatches = useSortingState()

  if (isError) {
    return (
      <div className="tw:container tw:mt-6 tw:text-red-500">
        There was an error loading the vendor summary. Error: {error.message}
      </div>
    )
  }

  return (
    <div className="tw:container tw:flex tw:flex-col tw:gap-6">
      <div>
        <PageTitle
          title={`Rewards Pending Approval for ${fulfillment_vendor_code}`}
          className="tw:mb-0!"
        />
        <Button
          type="button"
          variant="link"
          onClick={() => navigate("/ops/rewards")}
        >
          <MoveLeft />
          Return to All
        </Button>
      </div>

      <DataTable
        columns={tableColumnsVendorSummary}
        data={
          data?.pending?.channels?.filter(
            (channel) => channel.rewards_pending_approved_amount_count,
          ) ?? []
        }
        pending={isPending}
        onRowClick={(row) =>
          navigate(
            `/ops/rewards/${row.fulfillment_vendor_code}/${row.fulfillment_channel}`,
          )
        }
        {...sortingPending}
      />

      <div>
        <h4 className="tw:p-1">Fulfillment Batches</h4>
        <DataTable
          columns={tableColumnsFulfillmentBatches}
          data={data?.fulfillment_batches ?? []}
          pending={isPending}
          {...sortingBatches}
        />
      </div>
    </div>
  )
}
